import { GraphQLClient } from 'graphql-request'

import { getSdk, Sdk } from '../../graphql'

let sdk: Sdk | null = null

export const getGraphqlForClient = () => {
  if (!process.env.NEXT_PUBLIC_CLIENT_GRAPHQL_URL) {
    throw new Error('NEXT_PUBLIC_CLIENT_GRAPHQL_URL environment variable is not set')
  }

  if (!sdk) {
    sdk = getSdk(new GraphQLClient(process.env.NEXT_PUBLIC_CLIENT_GRAPHQL_URL))
  }
  return sdk
}
